import { createAction } from '@reduxjs/toolkit'

export const createDownloadActions = (typePrefix: string) => ({
  requestingStarted: createAction(`${typePrefix}/requestingStarted`),
  downloadStarted: createAction<{ totalBytes: number | null }>(`${typePrefix}/downloadStarted`),
  downloadProgress: createAction<{ loadedBytes: number }>(`${typePrefix}/downloadProgress`),
  downloadSucceeded: createAction(`${typePrefix}/downloadSucceeded`),
  downloadFailed: createAction<{ error: string }>(`${typePrefix}/downloadFailed`),
  processingStarted: createAction(`${typePrefix}/processingStarted`),
  downloadCancelled: createAction(`${typePrefix}/downloadCancelled`),
  resetDownload: createAction(`${typePrefix}/resetDownload`),
})

export type TDownloadActions = ReturnType<typeof createDownloadActions>
